export default "__VITE_ASSET__BKoVOEQK__"